<template>
  <div v-if="user" class="profile-container" data-aos="zoom-in">
    <base-info :user="user"/>
    <div class="user-info-container">
      <h1 class="heading">Profile</h1>
      <div class="user-info">
        <div class="full-name">
          <p class="name-text">Full name</p>
          <p class="user-name-text">
            {{ user.displayName ? user.displayName : "Anonymous" }}
          </p>
        </div>
        <hr />
        <div class="full-name">
          <p class="name-text">Email</p>
          <p class="user-name-text">{{ user.email }}</p>
        </div>
      </div>
      <button @click="logout" class="logout">Log out</button>
    </div>
  </div>
  <div v-else>
    <p>loading</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: null,
    };
  },
  computed: {
    userId() {
      return this.$store.getters.userData
        ? this.$store.getters.userData.id
        : "guest";
    },

    userProfileRoute() {
      return `/Orders/${this.userId}`;
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));

    this.$store.dispatch("checkLoggedIn");
  },
  methods: {
    logout() {
      this.$store.dispatch("logout/logout").then(() => {
        this.$router.push("/");
      });
    },
  },
};
</script>

<style scoped>
.profile-container {
  display: flex;
  gap: 150px;

  margin-top: 20px;
  padding: 0 60px 0 0;
}

ul {
  list-style-type: none;
}

.sidebar {
  width: clamp(20rem, 25rem, 35rem);
  margin-bottom: 15px;
}
.sidebar-list-item:nth-child(1) {
  height: 14rem;
  background: #e5e5e5;
}

.sidebar-list-item:nth-child(n + 2) {
  height: 7.2rem;
  background: #fafafa;
}
.sidebar-list-item {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 15px;

  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 10px 20px;
}
.sidebar-list-item {
  font-family: "Mabry Pro";
  color: #000;
  font-size: 1.8rem;
  font-weight: 500;
  justify-content: space-between;
}

.user-info-container {
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  max-width: 92rem;
  gap: 30px;
  width: 100%; 
}


.heading {
  color: #000;
  font-family: "Glusp";
  font-size: 2.4rem;
  font-weight: 700;
}

.user-info {
  height: 12rem;
  width: 100%;
  max-width: 92rem;
  min-width: 30rem;
  background: #fff;
  padding: 20px 32px;
  border-radius: 8px;
  margin-bottom: 50px;
}

.full-name {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.name-text {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.8rem;
  font-weight: 500;
}

.user-name-text {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.8rem;
  font-weight: 400;
  opacity: 0.6;
}

hr {
  margin-bottom: 25px;
}

button {
  width: 27rem;
  height: 65px;
  padding: 10px 22px;
  border-radius: 5px;
  border: 1px solid rgba(234, 67, 53, 0.3);
  background: #fff;
  color: #cb2c2c;
  font-size: 1.8rem;
  font-weight: 400;
}

@media screen and (min-width: 240px) and (max-width: 480px) {
  .profile-container {
    flex-direction: column;
    align-items: center;
    gap: 0;
    padding: 0;
    margin-top: 20px;
  }
  .user-info-container {
    padding: 20px;
    justify-content: center;
    align-items: center;
  }
  .user-info {
    margin: 0;
  }
}

@media screen and (min-width: 481px) and (max-width: 768px) {
  .profile-container {
    flex-direction: column;
    align-items: center;
    gap: 0;
    padding: 0;
    margin-top: 20px;
  }
  .user-info-container {
    padding: 20px;
    justify-content: center;
    align-items: center;
  }
  .user-info {
    margin: 0;
  }
}



</style>


